module.exports = __webpack_public_path__ + "media/img/pages/talent_career/hero-de-628f4045cd2a04e768fda8307a304865.jpg";